import { Alert, Collapse } from 'antd';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppModal } from 'shared/UI/UIKit/Modal';
import {
  prePublishErrorsColumns,
  translateErrorCode,
} from 'features/schedule-education-plans/model';
import { AppTable } from 'shared/UI/UIKit/Table';
import type { BellSchedule, ScheduleConfigurationPrePublishCheckDto } from 'services/api';

const { Panel } = Collapse;

interface PrePublishErrorsModalProps {
  visible: boolean;
  onCancel: () => void;
  handleConfirmPublish: () => void;
  prePublishErrors: Record<string, Omit<ScheduleConfigurationPrePublishCheckDto, 'code'>[]> | null;
  currentBellSchedule: BellSchedule | null;
}

export const PrePublishErrorsModal = ({
  visible,
  onCancel,
  handleConfirmPublish,
  prePublishErrors,
  currentBellSchedule,
}: PrePublishErrorsModalProps) => {
  if (!prePublishErrors) {
    return null;
  }

  const errorTable = (errorCode: string) => (
    <AppTable
      key={errorCode}
      columns={prePublishErrorsColumns(errorCode, currentBellSchedule)}
      dataSource={prePublishErrors[errorCode]}
      rowKey={(record: any, index) =>
        `${record.educationalClass?.id ?? 'unknown'}-${
          record.groupId ?? record.subjectId ?? 'unknown'
        }-${index ?? 'unknown'}`
      }
    />
  );

  const content = (
    <Collapse>
      {Object.keys(prePublishErrors).map((errorCode) => {
        const translation = translateErrorCode(errorCode);

        return (
          <Panel key={errorCode} header={translation.title}>
            <AppFlex direction="column" unit="16">
              <Alert message={translation.description} type="info" />
              {errorTable(errorCode)}
            </AppFlex>
          </Panel>
        );
      })}
    </Collapse>
  );

  return (
    <AppModal
      onCancel={onCancel}
      content={content}
      visible={visible}
      title="Нарушения"
      destroyOnClose
      size="large"
      footer={
        <AppFlex direction="row">
          <AppButton onClick={handleConfirmPublish}>Продолжить публикацию</AppButton>
          <AppButton type="outline" onClick={onCancel}>
            Отмена
          </AppButton>
        </AppFlex>
      }
    />
  );
};
